require('./brokerSubcriptionWizard.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const trim = require('lodash/string/trim');
const moment = require('moment');

// @components
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('commonsComponents/OKTooltip');
const BrokerFormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const WebappRender = require('components/conditionalRender/webappRender')
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');

// @constants
const {
    BROKER_SUBSCRIPTION_SIGNATURE_PATTERN_OPERATION_TYPE,
    BROKER_ORDER_TYPE_SUBSCRIPTION,
    BROKER_CORPORATE_OPERATIONS_SUBSCRIPTION_PRODUCT_TYPE,
    CHARGE_ACCOUNT_PREFIX,
    DATE_FORMAT_API,
    BROKER_SUBSCRIPTION_SIGNATURE_PATTERN_PARAM,
    BROKER_PRODUCT_TYPE_CAPITAL_INCREASE
} = require('constants/index');


//@contactCenter

const SubscriptionLegalConfirmation = require('components/contactCenter/brokerLegalConfirmation/subscriptionLegalConfirmation/subscriptionLegalConfirmation');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');

class BrokerSubscriptionWizard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedLegalConfirmationValue: SELECTED_VALUES.EMPTY,
        };

        this.handleLegalYesNoOptionChange = this.handleLegalYesNoOptionChange.bind(this);
    }

    handleLegalYesNoOptionChange(value) {
        this.setState({
            selectedLegalConfirmationValue: value
        });
    }

    getPrecontractualMailParams() {
        const { immProfileFields, immBrokerSubscription } = this.props;

        const controlDigit = trim(immBrokerSubscription.get('digitodecontrol'));
        const productNumber = trim(immBrokerSubscription.getIn(['contract', 'product']));
        const contractNumber = trim(immBrokerSubscription.getIn(['contract', 'number']));
        const idContract = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;

        const owner = trim(immBrokerSubscription.get('owner'));
        const momentEndDate = moment(immBrokerSubscription.getIn(['value', 'endDate']));

        return {
            productKID: '',
            contract: '',
            marketingReport: '',
            infoCcv: '',
            idOrder: '',
            market: '',
            termValidity: momentEndDate.format(DATE_FORMAT_API),
            holders: owner,
            leafletSusbcription: trim(immBrokerSubscription.get('linkTriptico')),
            cnmvDocumentation: trim(immBrokerSubscription.get('linkCNMV')),
            ccv: idContract,
            ccc: '',
            idContract: idContract,
            email: trim(PersonalDataHelper.getEmail(immProfileFields)),
            clientAlias: trim(immProfileFields.get('nombreCliente')),
            isin: trim(immBrokerSubscription.getIn(['value', 'isin'])),
            isinDescribe: trim(immBrokerSubscription.getIn(['value', 'descriptionValue'])),
            orderType: BROKER_ORDER_TYPE_SUBSCRIPTION,
            productType: BROKER_CORPORATE_OPERATIONS_SUBSCRIPTION_PRODUCT_TYPE,
            sharesNumber: '',
            sharesAmount: '',
            orderCondition: '',
            conditionPrize : '',
            currency: ' ',
            mifidWarningText: '',
            dateTime: '',
        };
    }

    builSubscriptionLegalConfirmation(bookletLabel, CNMVLabel) {
        const {
            immProfileFields,
            immPreContractualMail,
            immCorporatesOperation,
            currency,
            sendPreContractualMail,
            resetPrecontractualMail,
            requestProfile,
        } = this.props;

        return (
            <SubscriptionLegalConfirmation
                immCorporatesOperation={immCorporatesOperation}
                currency={currency}
                legalinformationLinks={[bookletLabel, CNMVLabel]}
                immPreContractualMail={immPreContractualMail}
                sendMail={sendPreContractualMail}
                sendMailParams={this.getPrecontractualMailParams()}
                resetMailState={resetPrecontractualMail}
                immProfileFields={immProfileFields}
                requestProfile={requestProfile}
                selectedYesNoOption={this.state.selectedLegalConfirmationValue}
                onYesNoOptionChange={this.handleLegalYesNoOptionChange}
            />
        );
    }

    render() {
        const {
            history,
            immBrokerSubscription,
            onChangeManifest,
            onCancelOperation,
            onSubmitOperation,
            setDocumentsRead
        } = this.props;

        const product = immBrokerSubscription.getIn(['contract', 'product']);
        const contractNumber = immBrokerSubscription.getIn(['contract', 'number']);
        const signaturePatternParams = {
            chargeAccount: `${BROKER_SUBSCRIPTION_SIGNATURE_PATTERN_PARAM}${product}${contractNumber}`
        };

        const bookletLabel = <FormattedText value="brokerSubscription-informativeMessageBookletLabel"/>
        const CNMVLabel = <FormattedText value="brokerSubscription-informativeMessageCNMVLabel"/>

        const checkBoxLabel = (
            <BrokerFormattedTextWithComponents
                value="brokerSubscription-informativeMessageCheckbox"
                injectedComponents={[bookletLabel, CNMVLabel]}
            />
        );

        const legalConfirmation = __CONTACT_CENTER__ ? this.builSubscriptionLegalConfirmation(bookletLabel, CNMVLabel) : null;
        const canContinue = !__CONTACT_CENTER__ || (this.state.selectedLegalConfirmationValue === SELECTED_VALUES.YES);
        const isin = immBrokerSubscription.getIn(['value', 'isin'])
        const iso = immBrokerSubscription.getIn(['value', 'iso'])
        const productDefinition = immBrokerSubscription.getIn(['value', 'descriptionValue'])
        const showWarning = immBrokerSubscription.get('showWarning')

        let documentsNotRead = null;
        if (showWarning) {
            documentsNotRead = (
                <div className="broker-rights-cash-exchange-step2__warning-message">
                    <OKMessage type="warning">
                        <FormattedText value="brokerLegalDocumentation-documentsRead" />
                    </OKMessage>
                </div>
            )
        }

        let signaturePattern = null;
        if (immBrokerSubscription.get('acceptedManifest')) {
            signaturePattern = (
                <div className="broker-subscription-wizard__bottom-border-section">
                    <SignaturePattern
                        operationType={BROKER_SUBSCRIPTION_SIGNATURE_PATTERN_OPERATION_TYPE}
                        operationParams={signaturePatternParams}
                    />
                </div>
            )
        }

        return (
            <OKSectionBox>
                {legalConfirmation}
                {
                    canContinue ?
                    (<div>
                        <h3 className="broker-subscription-wizard__title">
                            <FormattedText value="subscription-confirmSubscription" />
                        </h3>
                        <div className="broker-subscription-wizard__field">
                            <h4>
                                <FormattedText value="subscription-verifyInformation" />
                            </h4>
                        </div>
                        <WebappRender>
                            <BrokerLegalDocumentation
                                isin={isin}
                                iso={iso}
                                productDefinition={productDefinition}
                                productType={BROKER_PRODUCT_TYPE_CAPITAL_INCREASE}
                                reportCompleted={() => setDocumentsRead()}
                            />
                        </WebappRender>
                        <div className="broker-subscription-wizard__field">
                            <OKMessage>
                                <FormattedText value="subscription-important" />
                                <p>
                                    <FormattedText value="brokerSubscription-informativeMessageAlt" />
                                </p>
                            </OKMessage>
                        </div>
                        <WebappRender>
                            {documentsNotRead}
                            <OKTooltip
                                content={<FormattedText value={'planLegalDocumentDisclaimer-warningTooltip'}/>}
                                offset={[-50, -5]}
                                placement={'topLeft'}
                                target={
                                    <div className="broker-subscription-wizard__field">
                                        <OKCheckbox
                                            idName="manifestCheckbox"
                                            onChange={onChangeManifest}
                                            value={immBrokerSubscription.get('acceptedManifest')}
                                            label={checkBoxLabel}
                                            errorState={immBrokerSubscription.get('manifestInvalid')}
                                            errorMessage={formatText('brokerSubscription-manifestError')}
                                        />
                                    </div>
                                } />

                        </WebappRender>
                        {signaturePattern}
                    </div>) :
                    null
                }
                <div className="row">
                    <div className="col-xs-6">
                        <OKButton
                            modifier="link-ghost"
                            onClick={onCancelOperation}
                        >
                            <FormattedText value="subscription-cancel" />
                        </OKButton>
                    </div>
                    <div className="col-xs-6 text-right">
                        <div className="broker-subscription-wizard__footer-button">
                            <ContactCenterRender>
                                <SignaturePatternButton onClick={() => onSubmitOperation(history)} disabled={!canContinue}>
                                    <FormattedText value="subscription-subscribe" />
                                </SignaturePatternButton>
                            </ContactCenterRender>
                            <WebappRender>
                                <OKButton onClick={() => onSubmitOperation(history)}>
                                    <FormattedText value="subscription-subscribe" />
                                </OKButton>
                            </WebappRender>
                        </div>
                    </div>
                </div>
            </OKSectionBox>
        );
    }
}

BrokerSubscriptionWizard.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerSubscription: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    onChangeManifest: PropTypes.func.isRequired,
    onCancelOperation: PropTypes.func.isRequired,
    immCorporatesOperation: PropTypes.object.isRequired,
    currency: PropTypes.string,
    onSubmitOperation: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired
};

module.exports = withRouter(BrokerSubscriptionWizard);
